import { render, staticRenderFns } from "./ComplainTypeForm.vue?vue&type=template&id=c474654e&"
import script from "./ComplainTypeForm.vue?vue&type=script&lang=js&"
export * from "./ComplainTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports